<template>
<div>
  <div class="content">
    <van-cell-group inset class="form-card">
      <div class="section-title">
        <van-icon name="todo-list-o" size="18" color="#4080ff" />
        <span>作业用途</span>
      </div>

      <ChoseVehicleUsageNew
        :options="usageList"
        :modelValue="usageType"
        :disabled="valoreRequire"
        @update:modelValue="usageType = $event"
        @change="changeVehicleUsage"
      />
    </van-cell-group>  
    
    <van-form @submit="submitJsy">
      <!--蒸洗作业-->
      <div v-if="usageType == '1'">
        <van-cell-group inset>
          <div class="upload-jsz-front">
            <h2 class="jsz-titile input-title-hq red-required">本人驾驶证正页</h2>
            <div class="upload-jsz-front-box">
              <van-uploader :max-size="10 * 1024 * 1024" @oversize="onOversize" max-count="1" v-model="jsz_image" :before-read="beforeRead" :after-read="uploadJszFront" :before-delete="deleteJszFront"></van-uploader>
            </div>

            <div class="jsz-front-info-box">
              <van-field v-model="jsz_name" name="jsz_name" required :value="jsz_name" :rules="[{ validator:validatorJszName, message: '请填写姓名' }]" placeholder="请输入">
                <template #label>
                  <span class="input-left-label-hq">姓名</span>
                </template>
              </van-field>
              <van-field v-model="zjcx" name="zjcx" required :value="zjcx" :rules="[{ validator:validatorZjcx, message: '请填写准驾车型' }]" placeholder="请输入">
                <template #label>
                  <span class="input-left-label-hq">准驾车型</span>
                </template>
              </van-field>
              <van-field v-model="jsz_no" name="jsz_no" required :value="jsz_no" :rules="[{ validator:validatorJszNo, message: '请填写身份证' }]" placeholder="请输入">
                <template #label>
                  <span class="input-left-label-hq">身份证</span>
                </template>
              </van-field>
              <van-field v-model="telephone" name="telephone" required type="tel" :value="telephone" :rules="[{ validator:validatorJszTel, message: '请填写联系电话' }]" placeholder="请输入">
                <template #label>
                  <span class="input-left-label-hq">联系电话</span>
                </template>
              </van-field>
              <ChoseTime :timeVmodel="jszYxq" :timeName="jszYxq" :timeLabel="jszYxqLabel" @getYxq="getJszYxq" :timeValue="jsz_yx_time" />
            </div>
          </div>
        </van-cell-group>
      </div>

      <!--蒸洗+装卸作业-->
      <div v-if="usageType == '2'">
        <van-cell-group inset>
          <div class="upload-jsz-front">
            <h2 class="jsz-titile input-title-hq red-required">本人驾驶证正页</h2>
            <div class="upload-jsz-front-box">
              <van-uploader :max-size="10 * 1024 * 1024" @oversize="onOversize" max-count="1" v-model="jsz_image" :before-read="beforeRead" :after-read="uploadJszFront" :before-delete="deleteJszFront"></van-uploader>
            </div>

            <h2 class="jsz-titile input-title-hq red-required">本人驾驶证副页</h2>
            <div class="upload-jsz-front-box last-bottom">
              <van-uploader :max-size="10 * 1024 * 1024" @oversize="onOversize" max-count="1" v-model="jsz_fy_image" :before-read="beforeRead" :after-read="uploadJszFy" :before-delete="deleteJszFy"></van-uploader>
            </div>

            <div class="jsz-front-info-box">
              <van-field v-model="jsz_name" name="jsz_name" required :value="jsz_name" :rules="[{ validator:validatorJszName, message: '请填写姓名' }]" placeholder="请输入">
                <template #label>
                  <span class="input-left-label-hq">姓名</span>
                </template>
              </van-field>
              <van-field v-model="zjcx" name="zjcx" required :value="zjcx" :rules="[{ validator:validatorZjcx, message: '请填写准驾车型' }]" placeholder="请输入">
                <template #label>
                  <span class="input-left-label-hq">准驾车型</span>
                </template>
              </van-field>
              <van-field v-model="jsz_no" name="jsz_no" required :value="jsz_no" :rules="[{ validator:validatorJszNo, message: '请填写身份证' }]" placeholder="请输入">
                <template #label>
                  <span class="input-left-label-hq">身份证</span>
                </template>
              </van-field>
              <van-field v-model="telephone" name="telephone" required type="tel" :value="telephone" :rules="[{ validator:validatorJszTel, message: '请填写联系电话' }]" placeholder="请输入">
                <template #label>
                  <span class="input-left-label-hq">联系电话</span>
                </template>
              </van-field>
              <ChoseTime :timeVmodel="jszYxq" :timeName="jszYxq" :timeLabel="jszYxqLabel" @getYxq="getJszYxq" :timeValue="jsz_yx_time" />
            </div>
          </div>
        </van-cell-group>
        <div class="cyzgz">
          <van-cell-group inset>
            <div class="upload-cyzgz-front">
              <h2 class="jsz-titile input-title-hq red-required">从业资格证正面</h2>
              <div class="upload-cyzgz-front-box">
                <van-uploader :max-size="10 * 1024 * 1024" @oversize="onOversize" max-count="1" v-model="cyzgz_image" :before-read="beforeRead" :after-read="uploadCyzgzFront" :before-delete="deleteCyzgzFront"></van-uploader>
              </div>

              <h2 class="jsz-titile input-title-hq">从业资格证反面</h2>
              <div class="upload-cyzgz-front-box">
                <van-uploader :max-size="10 * 1024 * 1024" @oversize="onOversize" max-count="1" v-model="cyzgz_fm_image" :before-read="beforeRead" :after-read="uploadCyzgzFm" :before-delete="deleteCyzgzFm"></van-uploader>
              </div>

              <ChoseTime :timeVmodel="cyzgYxq" :timeName="cyzgYxq" :timeLabel="cyzgYxqLabel" @getYxq="getCyzgYxq" :timeValue="cyzgz_yx_time" />
            </div>
          </van-cell-group>
        </div>
      </div>
      
      <div style="margin: 1rem;">
        <van-button round block type="info" native-type="submit" class="addBtn" @loading="loadingBtn" color="#4080ff">
          保存
        </van-button>
      </div>
    </van-form>
  </div>
  <Tabbar></Tabbar>
</div>
</template>
<script>
import api from "@/fetch/api"
import {
  Toast,
  Dialog
} from 'vant';
import ChoseTime from "../Public/choseTime.vue"
import Compressor from 'compressorjs';
import Tabbar from '../Public/tabbarTpl.vue'
import ChoseVehicleUsageNew from '../Public/choseVehicleUsageNew.vue';
import autoSubmitBeian from '@/mixins/autoSubmitBeian';
export default {
  components: {
    ChoseTime,
    Tabbar,
    ChoseVehicleUsageNew
  },
  mixins: [autoSubmitBeian],
  data() {
    return {
      jsz_zm: '',
      cyzgz_zm: '',
      zjcx:'',
      jsz_image: [],
      cyzgz_image: [],
      jsz_fy_image: [],
      cyzgz_fm_image: [],
      jsz_name: "",
      jsz_no: "",
      telephone: "",
      jsz_yx_time: "",
      loadingBtn: false,
      jsz_url: "",
      jsz_fy_url: "",
      cyzgz_url: "",
      cyzgz_fm_url: "",
      cyzgz_yx_time: "",
      minDate: new Date(2020, 0, 1),
      maxDate: new Date(2025, 10, 1),
      currentDate: new Date(2021, 0, 17),
      showPickerDate: false,
      showPickerJszDate: false,
      id: "",
      jszYxq: "jsz_yx_time",
      jszYxqLabel: "驾驶证截至日期",
      cyzgYxq: "cyzgz_yx_time",
      cyzgYxqLabel: "从业资格证截至日期",
      // 车辆用途列表
      usageList: [],
      // 车辆用途类型
      usageType: '',
      timeRequire: true,
      valoreRequire: false 
    };
  },
  created() {
    document.title = "编辑驾驶员信息";
    var id = this.$route.params.id;
    this.$data.id = id;
    this.getDriverBeianDetail(id);
  },
  watch: {
    // 监听从业资格证截至日期变化
    cyzgz_yx_time(newVal) {
      if (this.usageType === '2' && newVal) {
        this.valoreRequire = true;
      } else if (this.usageType === '2') {
        this.valoreRequire = false;
      }
    }
  },
  methods: {
    //蒸洗，蒸洗+装卸货切换
    changeVehicleUsage(val) {
      this.usageType = val
      if(this.usageType == '1') {
        this.timeRequire = false
      } else {
        this.timeRequire = true;
      }
      // this.timeRequire = val !== '1';
    },
    // 获取车辆用途
    async getUsage() {
      try {
        const res = JSON.parse(await api.getTypeList('vehicleUsage'));
        if (res.success) {
          this.usageList = res.obj.filter((item) => {
            return item.typecode !== '';
          });
        } else {
          Toast.fail(res.message);
        }
      } catch (e) {
        console.log('获取车辆用途失败', e);
      }
    },
    beforeRead(file) {
      let quality = 0.6;
      if (file.size < 4 * 1024 * 1024) {
        quality = 0.9;
      } else if (file.size >= 4 * 1024 * 1024 && file.size < 8 * 1024 * 1024) {
        quality = 0.8;
      } else {
        quality = 0.6;
      }
      return new Promise((resolve) => {
        // compressorjs 默认开启 checkOrientation 选项
        // 会将图片修正为正确方向
        new Compressor(file, {
          quality: quality,
          success(result) {
            let newfile = new File([result], file.name, {
              type: file.type
            })
            resolve(newfile)
          },
          error(err) {
            console.log('图片压缩失败---->>>>>', err)
          }
        })

      });

    },
    onOversize() {
      Toast('文件大小不能超过 10Mb');
    },
    validatorJszName(val) {
      if (!val) {
        Toast.fail('请填写姓名');
        return false;
      }
      return val;
    },
    validatorZjcx(val) {
      if (!val) {
        Toast.fail('请填写准驾车型');
        return false;
      }
      return val;
    },
    validatorJszNo(val) {
      if (!val) {
        Toast.fail('请填写身份证');
        return false;
      }
      return val;
    },
    validatorJszTel(val) {
      if (!val) {
        Toast.fail('请填写联系电话');
        return false;
      }
      return val;
    },
    getDriverBeianDetail(id) {
      this.getUsage()
      var that = this;
      var weburl = that.GLOBAL.weburl;
      api.getDriverBeianDetail(id).then(function(resData) {
        var res = JSON.parse(resData);
        if (res.respCode == 0) {
          var detail = res.data;
          that.$data.jsz_url = detail.jiashizhengurl ? detail.jiashizhengurl : "";
          that.$data.jsz_fy_url = detail.jieshizhengfburl ? detail.jieshizhengfburl : "";
          that.$data.cyzgz_url = detail.congyezigeurl ? detail.congyezigeurl : "";
          that.$data.cyzgz_fm_url = detail.congyezigefmurl ? detail.congyezigefmurl : "";

          that.$data.jsz_image = detail.jiashizhengurl ? [{
            url: weburl + '/' + detail.jiashizhengurl
          }] : [];
          that.$data.jsz_fy_image = detail.jieshizhengfburl ? [{
            url: weburl + '/' + detail.jieshizhengfburl
          }] : [];
          that.$data.cyzgz_image = detail.congyezigeurl ? [{
            url: weburl + '/' + detail.congyezigeurl
          }] : [];
          that.$data.cyzgz_fm_image = detail.congyezigefmurl ? [{
            url: weburl + '/' + detail.congyezigefmurl
          }] : [];

          that.$data.jsz_name = detail.name;
          that.$data.jsz_no = detail.shenfenzheng;
          that.$data.telephone = detail.telphone;
          that.$data.jsz_yx_time = detail.jiashizhengyxq;
          that.$data.cyzgz_yx_time = detail.congyezigeyxq;
          that.$data.zjcx = detail.zjcx;

          that.usageType = detail.vehicleUsage;
          if(that.usageType == '1'){
            that.timeRequire = false;
          } else{
            that.timeRequire = true;
          }
        }
      }).catch(function() {
        Toast.fail('连接失败，请刷新页面');
      });
    },

    getJszYxq(xszYxq) {
      this.$data.jsz_yx_time = xszYxq
    },
    getCyzgYxq(xszYxq) {
      this.$data.cyzgz_yx_time = xszYxq
    },

    //上传驾驶证正页
    uploadJszFront(file) {
      file.status = 'uploading';
      file.message = '上传中...';
      var that = this;
      const weburl = that.GLOBAL.weburl;
      let formData = new FormData();
      formData.append("uploadpics", file.file);
      formData.append("ctid", '');
      api.uploadJszFront(formData).then(function(res) {
        var resData = JSON.parse(res);
        if (resData.respCode == "0") {
          var imageData = resData.data;
          that.$data.jsz_image = imageData.jiashizhengurl ? [{
            url: weburl + '/' + imageData.jiashizhengurl
          }] : that.$data.jsz_image;
          that.$data.jsz_url = imageData.jiashizhengurl ? imageData.jiashizhengurl : that.$data.jsz_url;
          that.$data.jsz_name = imageData.name ? imageData.name : that.$data.jsz_name;
          that.$data.jsz_no = imageData.shenfenzheng ? imageData.shenfenzheng : that.$data.jsz_no;
          that.$data.telephone = imageData.telephone ? imageData.telephone : that.$data.telephone;
          that.$data.jsz_yx_time = imageData.jiashizhengyxq ? imageData.jiashizhengyxq : that.$data.jsz_yx_time;
          that.$data.zjcx = imageData.zjcx ? imageData.zjcx:that.$data.zjcx;
        } else {
          setTimeout(() => {
            file.status = 'failed';
            file.message = '上传失败';
          }, 1000);
          Toast.fail(resData.message);
        }
      }).catch(function() {
        Toast.fail('上传图片失败，请重新再试');
        setTimeout(() => {
          file.status = 'failed';
          file.message = '上传失败';
        }, 1000);
      });
    },
    //上传驾驶证副页
    uploadJszFy(file) {
      file.status = 'uploading';
      file.message = '上传中...';
      var that = this;
      const weburl = that.GLOBAL.weburl;
      let formData = new FormData();
      formData.append("uploadpics", file.file);
      formData.append("ctid", '');
      api.uploadJszFront(formData).then(function(res) {
        var resData = JSON.parse(res);
        if (resData.respCode == "0") {
          var imageData = resData.data;
          that.$data.jsz_fy_image = [{
            url: weburl + '/' + imageData.jiashizhengurl
          }];
          that.$data.jsz_fy_url = imageData.jiashizhengurl ? imageData.jiashizhengurl : "";
        } else {
          setTimeout(() => {
            file.status = 'failed';
            file.message = '上传失败';
          }, 1000);
          Toast.fail(resData.message);
        }
      }).catch(function() {
        Toast.fail('上传图片失败，请重新再试');
        setTimeout(() => {
          file.status = 'failed';
          file.message = '上传失败';
        }, 1000);
      });
    },
    //上传从业资格证
    uploadCyzgzFront(file) {
      file.status = 'uploading';
      file.message = '上传中...';
      var that = this;
      const weburl = that.GLOBAL.weburl;
      let formData = new FormData();
      formData.append("uploadpics", file.file);
      formData.append("ctid", '');
      api.uploadCyzgz(formData).then(function(res) {
        var resData = JSON.parse(res);
        if (resData.respCode == "0") {
          var imageData = resData.data;
          that.cyzgz_image = [{
            url: weburl + '/' + imageData.congyezigeurl
          }];
          that.cyzgz_url = imageData.congyezigeurl ? imageData.congyezigeurl : "";
          if(imageData.congyezigeyxq) that.cyzgz_yx_time = imageData.congyezigeyxq;
          if(that.jsz_name != imageData.name && that.jsz_name)
          {
            Toast.fail("证件姓名与登记姓名不符合");
          }
        }
        else if(resData.respCode == "-1" && resData.data != null)
        {
          Toast.fail(resData.message);
          var imageData2 = resData.data;
          that.cyzgz_image = [{
            url: weburl + '/' + imageData2.congyezigeurl
          }];
          that.cyzgz_url = imageData2.congyezigeurl ? imageData2.congyezigeurl : "";
        } 
        else {
          setTimeout(() => {
            file.status = 'failed';
            file.message = '上传失败';
          }, 1000);
          Toast.fail(resData.message);
        }
      }).catch(function() {
        Toast.fail('上传图片失败，请重新再试');
        setTimeout(() => {
          file.status = 'failed';
          file.message = '上传失败';
        }, 1000);
      });
    },
    uploadCyzgzFm(file) {
      file.status = 'uploading';
      file.message = '上传中...';
      var that = this;
      const weburl = that.GLOBAL.weburl;
      let formData = new FormData();
      formData.append("uploadpics", file.file);
      formData.append("ctid", '');
      api.uploadCyzgz(formData).then(function(res) {
        var resData = JSON.parse(res);
        if (resData.respCode == "0") {
          var imageData = resData.data;
          that.cyzgz_fm_image = [{
            url: weburl + '/' + imageData.congyezigeurl
          }];
          that.cyzgz_fm_url = imageData.congyezigeurl ? imageData.congyezigeurl : "";
          if(imageData.congyezigeyxq) that.cyzgz_yx_time = imageData.congyezigeyxq;
          // if(that.jsz_name != imageData.name && that.jsz_name)
          // {
          //   Toast.fail("证件姓名与登记姓名不符合");
          // }
        }
        else if(resData.respCode == "-1" && resData.data != null)
        {
          Toast.fail(resData.message);
          var imageData2 = resData.data;
          that.cyzgz_image = [{
            url: weburl + '/' + imageData2.congyezigeurl
          }];
          that.cyzgz_url = imageData2.congyezigeurl ? imageData2.congyezigeurl : "";
        }
        else {
          setTimeout(() => {
            file.status = 'failed';
            file.message = '上传失败';
          }, 1000);
          Toast.fail(resData.message);
        }
      }).catch(function() {
        Toast.fail('上传图片失败，请重新再试');
        setTimeout(() => {
          file.status = 'failed';
          file.message = '上传失败';
        }, 1000);
      });
    },
    isCardNo(card) {
      //身份证号码为15位或者18位，15位时全为数字，18位前17位为数字，最后一位是校验位，可能为数字或字符X
      var reg = /(^\d{17}(\d|X|x)$)/;
      if (reg.test(card) === false) {
        return false;
      }
      return true;
    },
    //提交表单
    submitJsy(values) {
      if (this.usageType == '1') {
        let that = this;
        let openid = that.$store.state.wx_info.openid;
        let jiashizhengurl = that.jsz_url ? that.jsz_url : "";
        if (!jiashizhengurl) {
          Toast.fail('请上传驾驶证正页');
          return false;
        }
        let shenfenzheng = values.jsz_no ? values.jsz_no : "";
        if(!this.isCardNo(shenfenzheng))
        {
          Toast.fail('身份证号码格式不正确');
          return false;
        }

        let id = that.$data.id;
        that.$data.loadingBtn = true;
        let formData = JSON.stringify({
          congyezigeurl: '',
          congyezigefmurl: '',
          congyezigeyxq: '',
          jiashizhengurl: jiashizhengurl,
          jieshizhengfburl: '',
          jiashizhengyxq: that.jsz_yx_time ? that.jsz_yx_time : "",
          name: values.jsz_name ? values.jsz_name : "",
          openid: openid,
          shenfenzheng: shenfenzheng,
          telphone: values.telephone ? values.telephone : "",
          zjcx:values.zjcx?values.zjcx:"",
          id: id,
          vehicleUsage: that.usageType
        });

        api.updateBeianJsz(formData).then(function(res) {
          var resData = JSON.parse(res);
          if (resData.respCode == "0") {
            Dialog.alert({
              message: '信息保存成功',
            }).then(() => {
              that.$router.push({
                name: 'driverList'
              })
            });
          } else {
            Dialog.alert({
              message: resData.message,
            }).then(() => {
              // on confirm
            });
          }
        }).catch(function() {
          that.$data.loadingBtn = false;
          Toast.fail('连接失败，请刷新页面');

        });

      } else {
        let that = this;
        let openid = that.$store.state.wx_info.openid;
        let jiashizhengurl = that.jsz_url ? that.jsz_url : "";
        let jieshizhengfburl = that.jsz_fy_url ? that.jsz_fy_url : "";
        let congyezigeurl = that.cyzgz_url ? that.cyzgz_url : "";
        let congyezigefmurl = that.cyzgz_fm_url ? that.cyzgz_fm_url : "";
        if (!jiashizhengurl) {
          Toast.fail('请上传驾驶证正页');
          return false;
        }
        if (!jieshizhengfburl) {
          Toast.fail('请上传驾驶证副页');
          return false;
        }
        if (!congyezigeurl) {
          Toast.fail('请上传从业资格证');
          return false;
        }

        let shenfenzheng = values.jsz_no ? values.jsz_no : "";
        if(!this.isCardNo(shenfenzheng))
        {
          Toast.fail('身份证号码格式不正确');
          return false;
        }

        let id = that.$data.id;
        that.$data.loadingBtn = true;
        let formData = JSON.stringify({
          congyezigeurl: congyezigeurl,
          congyezigefmurl: congyezigefmurl,
          congyezigeyxq: that.cyzgz_yx_time ? that.cyzgz_yx_time : "",
          jiashizhengurl: jiashizhengurl,
          jieshizhengfburl: jieshizhengfburl,
          jiashizhengyxq: that.jsz_yx_time ? that.jsz_yx_time : "",
          name: values.jsz_name ? values.jsz_name : "",
          openid: openid,
          shenfenzheng: shenfenzheng,
          telphone: values.telephone ? values.telephone : "",
          zjcx:values.zjcx?values.zjcx:"",
          id: id,
          vehicleUsage: that.usageType
        });

        api.updateBeianJsz(formData).then(function(res) {
          var resData = JSON.parse(res);
          if (resData.respCode == "0") {
            if (that.usageType == '2') {
              that.autoSubmitBeian('driver', id, 'driverList');
            } else {
              Dialog.alert({
                message: '信息保存成功',
              }).then(() => {
                that.$router.push({
                  name: 'driverList'
                })
              });
            }
          } else {
            Dialog.alert({
              message: resData.message,
            }).then(() => {
              // on confirm
            });
          }
        }).catch(function() {
          that.$data.loadingBtn = false;
          Toast.fail('连接失败，请刷新页面');

        });
      }

    },
    deleteJszFront() {
      this.$data.jsz_image = [];
      this.$data.jsz_url = "";
    },
    deleteJszFy() {
      this.$data.jsz_fy_image = [];
      this.$data.jsz_fy_url = "";
    },
    deleteCyzgzFront() {
      this.$data.cyzgz_image = [];
      this.$data.cyzgz_url = "";
    },
    deleteCyzgzFm() {
      this.$data.cyzgz_fm_image = [];
      this.$data.cyzgz_fm_url = "";
    },

  }

}
</script>

<style lang="scss" scoped>
.content {
    margin: 1rem 0 3.75rem 0;
    padding-bottom: env(safe-area-inset-bottom);
}
.upload-jsz-front {
  //border-top: 1px solid #ececec;
  background: #fff;
  padding-top: .625rem;
  .jsz-titile {
      padding: 0.675rem 1rem;
      color: #646566;
  }

  .upload-jsz-front-box {
      margin:0 1rem;
  }
  .last-bottom {
    padding-bottom: 0.625rem;
    border-bottom: 1px solid #ebedf0;
  }
}

.cyzgz{
  margin-top: 1rem;
}
.upload-cyzgz-front {
    margin-top: 0.625rem;
    //border-top: 1px solid #ececec;
    background: #fff;
    .jsz-titile {
        padding: 0.675rem 1rem;
    }
    .upload-cyzgz-front-box {
        margin-left: 1rem;
    }
}

.form-card {
  margin-bottom: 1rem;
  border-radius: 0.5rem;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.05);
  overflow: hidden;
}

.section-title {
  display: flex;
  align-items: center;
  padding: 0.75rem 1rem;
  background: #f7f8fa;
  border-bottom: 1px solid #ebedf0;

  span {
    margin-left: 0.5rem;
    font-size: 15px;
    font-weight: 500;
    color: #323233;
  }
}
</style>
